import axios from 'axios';

export async function getReport(reportId:string|undefined, token: string) {
    const url = `PowerBI/Report?reportId=` + reportId; // TODO: Authenticate dynamically during Task #2088
    return axios.get(url, { headers: { Authorization: `Bearer ${token}`}});
}